import React from 'react';
import { motion } from 'framer-motion';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const finalCtaContent = {
  title: '¿Listo para transformar tu práctica clínica?',
  subtitle: 'No pierdas más tiempo buscando material. Empezá hoy mismo a acompañar el neurodesarrollo infantil con herramientas clínicas profesionales.',
  ctaText: 'SÍ, QUIERO EL MEGAPACK',
  // 👉 URL DE COMPRA
  ctaLink: 'https://habitandomicuerpo.shop/products/megapack-estimulacion-temprana-%E2%9C%A8'
};
export function FinalCTA() {
  return <section className="py-24 px-4 bg-brand-accent relative overflow-hidden" data-id="element-94">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-95" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-96">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-serif mb-6 text-white" data-id="element-97">
          {finalCtaContent.title}
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-red-100/80 font-sans mb-10 max-w-2xl mx-auto" data-id="element-98">
          {finalCtaContent.subtitle}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-99">
          <a href={finalCtaContent.ctaLink} target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-brand-accent hover:bg-brand-light font-bold py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-105 shadow-xl" data-id="element-100">
            {finalCtaContent.ctaText}
          </a>
        </motion.div>
      </div>
    </section>;
}